var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartner2Backdrop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 471,
    height: 357,
    viewBox: "0 0 471 357",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_631_51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288 347H131V336H0.0615234V305H131V282H288V347ZM395 53H279V12H395V53ZM126.914 9.96777H238.694V52.9678H122.694V42H10.9141V0H126.914V9.96777ZM470.939 44H420.939V5H470.939V44Z",
    fill: "url(#paint0_linear_631_51)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_631_51",
    x: -199.938,
    y: -200,
    width: 870.878,
    height: 747,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_631_51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_631_51",
    x1: 235.5,
    y1: -6.04513e-7,
    x2: 235.5,
    y2: 357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFFEF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8088FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner2Backdrop);
export default __webpack_public_path__ + "static/media/partner_2_backdrop.5c715c7643dead51155cb5be95adfd9f.svg";
export { ForwardRef as ReactComponent };